import { render, staticRenderFns } from "./BudgetComponent.vue?vue&type=template&id=4b4fd2c3&scoped=true"
import script from "./BudgetComponent.vue?vue&type=script&lang=js"
export * from "./BudgetComponent.vue?vue&type=script&lang=js"
import style0 from "./BudgetComponent.vue?vue&type=style&index=0&id=4b4fd2c3&prod&lang=scss&scoped=true"
import style1 from "./BudgetComponent.vue?vue&type=style&index=1&id=4b4fd2c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4fd2c3",
  null
  
)

export default component.exports